module.exports = __webpack_public_path__ + "static/media/thumbnail-el-filo.221c7dc9.jpg";